import { format as formatWithTimezone } from "date-fns-tz";

import { locale } from "./datetime";

const CONDENSED_FULL_SENTENCE_FORMAT = "E d MMM yyyy 'at' h:mm a z";

/**
 * Format the date time in its lean form.
 *
 * ✅ This is part of the Cadmus standardised date/duration formatting.
 *
 * {@link https://docs.google.com/spreadsheets/d/1XO8M5bPTAd-uVWCaygIGt9ch1BDOtZCV2zHZxPNtmbg/edit#gid=21065173 Style guide}
 * @example formatCondensedFullSentence(new Date("2021-09-17T13:59:00.000Z"))
 * // returns "Wed 17 Sep 2023 at 1:30 PM AEST"
 */
export const formatCondensedFullSentence = (date: Date): string => {
  return `${formatWithTimezone(date, CONDENSED_FULL_SENTENCE_FORMAT, {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: locale,
  })}`;
};
